import { TraitRegistryCategory } from '../../../registry/trait/TraitRegistryCategory';
import { HideStrategy } from '../../../classes/learnware/LearnwareEnums';
import { TraitTypeSelect } from '../../../registry/trait/traitTypes/TraitTypeSelect';
export class TraitsOrderedChoice extends TraitRegistryCategory {
    label = 'Ordered Choice';
    constructor(parent) {
        super(parent);
        super.init();
    }
    hideStrategy = () => new TraitTypeSelect({
        default: HideStrategy.ShowAll
        /*  select: Object.entries(HideStrategy).map(([label, value]) => [value, label]) as any */
    });
}
